import { CalendarBodyWrapper } from "../StyledComponents";
import WeekDays from "./WeekDays";

interface Props {
    week: number;
    setWeekInterval: React.Dispatch<
        React.SetStateAction<readonly [Date, Date]>
    >;
    isSettings?: boolean;
}

const CalendarBody = ({ week, setWeekInterval, isSettings = false }: Props) => (
    <CalendarBodyWrapper isSettings={isSettings}>
        <WeekDays
            setWeekInterval={setWeekInterval}
            week={week}
            isSettings={isSettings}
        />
    </CalendarBodyWrapper>
);

export default CalendarBody;
